import { BUSINESS_INFO } from '@/common/businessInfo';

/**
 * 세미나 참가비 결제·취소·환불 정책 본문.
 * - 환불율 구간·동영상 규칙(접속 후 환불 불가, 상시 동영상 결제 후 7일·접속 전)은
 *   백엔드 RefundPolicy(core/seminar/payment/domain/RefundPolicy.kt)와 반드시 일치시킬 것.
 * - PG(토스페이먼츠) 카드사 심사용 "환불 정책 확인 가능한 URL"(/refund-policy)로도 쓰인다.
 */

/** 시행일·버전 — 2026-10-11 개정(동영상 환불 규정 추가·취소 경로 정정). 결제 건이 없어 공지 없이 바로 시행(사용자 결정) */
export const REFUND_POLICY_VERSION = '2026-10-11';

/** 결제 후 7일 이내 청약철회 — 세미나 시작 전이면 아래 기간별 규정보다 우선해 전액 환불 (백엔드 RefundPolicy.WITHDRAWAL_DAYS) */
export const REFUND_WITHDRAWAL_RULE: string = '결제 후 7일 이내 취소 시(세미나 시작 전에 한함) 전액(100%) 환불';

/** 세미나 참가비 환불 규정 (참가자 자발 취소, 세미나 시작 일시 기준). rate는 현재 적용 구간 강조에 사용 */
export const REFUND_POLICY_RULES: { rate: number; text: string }[] = [
    { rate: 100, text: '세미나 시작 7일 전까지 취소 시 전액(100%) 환불' },
    { rate: 50, text: '세미나 시작 3일 전까지 취소 시 50% 환불' },
    { rate: 0, text: '세미나 시작 3일 이내 취소 시 환불 불가' },
];

export const REFUND_POLICY: string = `
${BUSINESS_INFO.serviceName}(${BUSINESS_INFO.companyName}, 이하 "회사")가 운영하는 세미나 서비스의 참가비 결제, 취소 및 환불에 관한 정책입니다.

제1조 (판매 상품 및 서비스 제공 기간)
1. 판매 상품: 회사 플랫폼에 등록된 유료 세미나(명치사 커리어 세미나)의 참가권입니다. 참가권은 세미나 상세 페이지에 표시된 일시·장소(또는 온라인)에서 진행되는 해당 세미나에 1인이 참석할 수 있는 권리입니다.
2. 서비스 제공 기간: 결제 완료 시점부터 세미나 상세 페이지에 표시된 세미나 종료 일시까지입니다. 세미나 일시는 상품(세미나 상세) 페이지에 명확히 표시되며, 모집 종료일은 항상 세미나 시작일 이전으로 설정됩니다. 다만 정해진 일시 없이 계속 판매되는 동영상 세미나(이하 "상시 동영상 세미나")는 결제 완료 시점부터 계속 볼 수 있으며, 판매가 끝난 뒤에도 볼 수 있습니다.
3. 결제 금액: 세미나 상세 페이지에 표시된 참가비(원, 부가세 포함)이며, 결제창에서 동일 금액이 다시 표시됩니다.

제2조 (결제 수단)
1. 결제는 전자결제대행사(PG) 토스페이먼츠를 통해 이루어지며, 신용·체크카드, 계좌이체, 간편결제 등 결제창에서 제공되는 수단을 이용할 수 있습니다.
2. 회사는 카드번호 등 결제수단 정보를 직접 보관하지 않으며, 결제 정보는 PG사가 관련 법령에 따라 보관합니다.

제3조 (참가 신청 취소 및 환불 기준)
1. 결제 후 7일 이내에는 세미나 시작 전이라면 아래 제2항과 관계없이 결제 금액 전액(100%)을 환불합니다(청약철회).
2. 제1항의 기간이 지난 뒤 참가자 본인의 사정으로 취소하는 경우, 세미나 시작 일시를 기준으로 아래 환불율이 적용됩니다.
${REFUND_POLICY_RULES.map((rule) => `  - ${rule.text}`).join('\n')}
3. 세미나가 이미 시작된 후에는 취소 및 환불이 불가합니다.
4. 동영상 세미나는 참가자가 시청(접속) 링크를 처음 연 뒤에는 취소 시점과 관계없이 취소 및 환불이 불가합니다. 링크를 열기 전에는 제1항부터 제3항까지(상시 동영상 세미나는 제5항)를 따릅니다.
5. 상시 동영상 세미나는 제1항부터 제3항까지를 적용하지 않고, 결제 후 7일 이내이고 시청(접속) 링크를 열기 전이면 결제 금액 전액(100%)을 환불합니다. 결제 후 7일이 지나면 취소 및 환불이 불가합니다.
6. 아래의 경우에는 취소 시점과 시청(접속) 여부와 관계없이 결제 금액 전액(100%)이 환불됩니다.
  - 강사가 참가 신청을 거절한 경우
  - 강사 귀책 또는 회사 사정으로 세미나가 폐강(취소)된 경우
  - 회사의 귀책사유로 결제 오류가 발생한 경우
7. 환불율 산정 시 "세미나 시작 N일 전"은 취소 요청 시각부터 세미나 시작 일시까지 남은 시간을 24시간 단위로 계산하고, "결제 후 7일"은 결제 완료 시각부터 계산합니다.
8. 결제 전 구매 확인 화면과 결제 완료 화면·안내 메일에 결제 시각 기준 환불 일정(날짜별 환불율)을 안내합니다.
9. 환불 시 결제대행 수수료 등 별도 비용을 차감하지 않습니다. 위 환불율에 따른 금액을 그대로 환불합니다.

제4조 (환불 방법 및 소요 기간)
1. 환불은 원 결제수단으로 취소(부분 취소 포함) 처리됩니다.
2. 카드 결제는 취소 즉시 PG사에 취소 요청이 전달되며, 카드사 사정에 따라 승인 취소 반영까지 영업일 기준 3~7일이 소요될 수 있습니다. 계좌이체·간편결제는 각 결제사 정책에 따라 영업일 기준 3~7일 내 환불됩니다.
3. 취소는 로그인 후 [마이페이지 › 세미나 이력]에서 직접 신청할 수 있으며, 취소 전 환불 예정 금액이 안내됩니다.

제5조 (통신판매중개자 고지)
회사는 통신판매중개자로서 거래 당사자가 아니며, 세미나의 내용·진행·품질에 대한 책임은 세미나를 등록한 강사에게 있습니다. 다만 결제·취소·환불 처리는 회사가 PG사를 통해 대행합니다.

제6조 (문의)
결제·환불 관련 문의는 아래로 연락해 주세요.
  - 이메일: ${BUSINESS_INFO.email}
  - 사이트 내 [문의하기] 메뉴
${BUSINESS_INFO.phone ? `  - 전화: ${BUSINESS_INFO.phone}` : ''}

사업자 정보
  - 상호명: ${BUSINESS_INFO.companyName}
  - 대표자명: ${BUSINESS_INFO.representative}
  - 사업자등록번호: ${BUSINESS_INFO.registrationNumber}
${BUSINESS_INFO.mailOrderSalesNumber ? `  - 통신판매업신고번호: ${BUSINESS_INFO.mailOrderSalesNumber}\n` : ''}${BUSINESS_INFO.address ? `  - 사업장주소: ${BUSINESS_INFO.address}\n` : ''}${BUSINESS_INFO.phone ? `  - 유선전화번호: ${BUSINESS_INFO.phone}\n` : ''}
부칙
  - 개정일: 2026-10-11
본 정책은 ${REFUND_POLICY_VERSION}부터 시행합니다.
`.trim();
